export const ComputeSymbol = Symbol('compute')
export const SceneCodesSymbol = Symbol('scenecodes')
